import type { ReactNode } from 'react';
import React from 'react';

import DialogContent from '@mui/material/DialogContent';

import StdDialog from 'components/Dialogs/StdDialog';

export const DIALOG_TYPE_EMPTY_DIALOG = 'DIALOG_TYPE_EMPTY_DIALOG';

const EmptyDialog = ({ content, dialogId, ...otherProps }: { content: ReactNode; dialogId: string }) => {
  return (
    <StdDialog sharedcomponentid={'DIALOG_TYPE_EMPTY_DIALOG'} {...otherProps}>
      <DialogContent>{content}</DialogContent>
    </StdDialog>
  );
};

export default EmptyDialog;
